// [uTheory](http://utheory.com) - Copyright (c) Gregory Ristow 2014
//
// ## Blank for Interactive Game
//
// Include description of object & useful info here, please!
import Mousetrap from 'mousetrap';
import InteractivePrototype from './interactivePrototype.ts';
import * as Notation from '../notation.ts';
import utils from '../utils.ts';

class PianoLabelNoteNames extends InteractivePrototype {
  constructor(displayDiv, options) {
    super();
    this.targetSpeedFromSkills = PianoLabelNoteNames.registry.skills;
    this.settings = {
      instructions: true,
      editor: false,
      notation: false,
      piano: {
        lowestNote: 'C4',
        highestNote: 'C5',
        listeners: false,
        ariaLive: 'alert',
        ariaNoteDescriptionType: 'location',
      },
      letters: { letterButtons: true },
      checkMark: {},
      player: {},
      oneTryOnly: false,
      progressTracker: true,
    };

    this.init(displayDiv, options);
  }

  init(displayDiv, options) {
    // now call the prototype's init function:
    super.init(displayDiv, options);
  }

  generateQuestions() {
    this.questionText = [
      'C',
      'D',
      'E',
      'F',
      'G',
      'A',
      'B',
      'C5',
      'C#',
      'Db',
      'D#',
      'Eb',
      'F#',
      'Gb',
      'G#',
      'Ab',
      'A#',
      'Bb',
    ];

    utils.shuffle(this.questionText);

    this.questionText = this.questionText.concat(utils.shuffle(['Fb', 'B#3', 'Cb5', 'E#', 'B#4']));

    this.questions = [];
    this.questionText.forEach((text) => {
      this.questions.push({
        text,
        skills: this.calculateSkill(text),
      });
    }, this);

    this.questionPrompt = 'Name the highlighted note.';
  }

  calculateSkill(answer) {
    switch (answer[1]) {
      case '#':
        return 10;
      case 'b':
        return 11;
      default:
        if (answer[0] === 'A' || answer[0] === 'B') return 2;
        return 1;
    }
  }

  newQuestion() {
    this.question = this.questions[this.questionNumber];
    this.note = new Notation.Note(this.question.text);
    // Color the piano:
    this.piano.clearColors();
    this.piano.colorNote(this.question.text);

    // Set a label, without giving away the answer:
    const answer = this.question.text;
    const { accidental } = this.note;
    const labelText = `_${accidental}`;

    const secondaryLabel = this.questionNumber > 17 || accidental === 'b';
    this.secondaryLabel = secondaryLabel;

    this.piano.labelNote(answer, labelText, secondaryLabel);

    // Set the button accidentals, to be clear:
    this.letterPanel.setLettersAccidental(accidental);
    super.newQuestion();
  }

  checkAnswer(letter) {
    if (this.rightAnswerDelay) return;
    if (letter[0] === this.question.text[0]) {
      this.piano.labelNote(this.question.text, this.note.toShortString(), this.secondaryLabel);
      this.rightAnswer(500);
    } else {
      this.wrongAnswer(100);
    }
  }

  gameOver() {
    this.instructionsDiv.innerHTML = 'Notes of the Piano:';
    this.piano.clearColors();
    Mousetrap.reset();
    this.lettersDiv.style.display = 'none';
    window.setTimeout(() => {
      super.gameOver();
    }, 2000);
  }

  playAnswer() {
    const note = new Notation.Note(this.question.text);
    this.player.play(note.getMidiNumber(), { startTime: 0, stopTime: 2 });
  }

  addListeners() {
    this.letterPanel.addLetterCallback(this.checkAnswer, this);
  }
}

PianoLabelNoteNames.registry = {
  description: 'Label the notes of the piano',
  skills: ['sharps', 'flats'],
  options: {},
};

export default PianoLabelNoteNames;
